<template>
  <div class="">
    <ValidationObserver v-slot="{ handleSubmit }" ref="validationObserver">
      <form @submit.prevent="handleSubmit(submit)" ref="form">
        <div :class="inList ? 'page-container py-0' : 'page-container bg-white '">
          <div class="d-flex mb-2 justify-content-center select-business">
            <SearchFilters
            :showSearchBox="showSearchBox"
            @businessChange="handleBusinessChange"
            :showBranchSelector="false"
            @update:searchQuery="searchQuery = $event"
            />
          </div>
          <FormGenerator :Fields="Fields" :model="data" :options="options" />
          <div class="text-right">
            <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
            <b-button
              v-else
              variant="primary"
              type="warning"
              native-type="submit"
              >Submit</b-button
            >
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { listBusinessSetting, setBusinessSetting } from "@/API/BusinessAPIs";
import { Fields, Models, options } from "./form_fields";
import FormGenerator from "@/components/FormGenerator/FormGenerator.vue";
import SearchFilters from "@/components/SearchFilters.vue";
import { CurrencyOptions } from "@/config/options";
export default {
  components: { FormGenerator, SearchFilters },
  props: ["id", "model"],
  name: "BusinessSettingsTab",
  data() {
    return {
      loading: false,
      showSearchBox: false,
      businessId: null,
      data: JSON.parse(JSON.stringify(Models)),
      options: options,
      Fields: Fields,
      emptyModel: null,
      inList: false,
      rules: {
        Address: [
          { required: true, message: "Please enter the name", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    userBusinesses() {
      return this.$store.state.User.user.business || [];
    }
  },
  async mounted() {
    this.businessId = this.$store.state.User?.user?.business?.[0]?.id;
    this.emptyModel = JSON.stringify(Models);
    this.businessId && (await this.getData());
    this.options.CurrencyOptions = await CurrencyOptions();
    let typeField = this.Fields.find(field => field.name === "Currency");
    if (typeField) {
      typeField.options = this.options.CurrencyOptions;
    }
  },
  watch: {
    businessId: {
      immediate: true,
      handler(newBusinessID, oldBusinessID) {
        if (newBusinessID && newBusinessID !== oldBusinessID) {
          this.getData();
        }
      }
    },
    userBusinesses: {
      handler(newBusinesses) {
        if (newBusinesses.length > 0 && !this.businessId) {
          this.businessId = newBusinesses[0].id;
          this.getData();
        }
      },
    },
    model: {
      deep: true,
      handler(value) {
        this.data = value;
      }
    }
  },
  methods: {
    handleBusinessChange(newValue) {
      if (newValue !== this.businessId) {
        this.businessId = newValue;
      }
    },
    getLocalizedName(locales) {
      const locale = this.$i18n.locale || "en";
      const localizedData =
        locales.find(l => l.locale === locale) || locales[0];
      return localizedData ? localizedData.name : "No Name";
    },

    async getData() {
      this.data = { ...JSON.parse(this.emptyModel) };
      let settingData = await listBusinessSetting({
        businessId: this.businessId
      });
      settingData.forEach(set => {
        this.$set(this.data, set.key, set.data);
      });
    },
    modelToSubmitDataConverter() {
      var data = [];
      for (const [key, value] of Object.entries(this.data)) {
        if (value !== null && value !== "") {
          data.push({ key: key, data: value });
        }
      }
      return data;
    },

    async submit() {
      this.loading = true;
      let submitData = this.modelToSubmitDataConverter();
      await setBusinessSetting(this.businessId, submitData);
      this.loading = false;
    }
  }
};
</script>
